"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A description of a tensor.
 */
var Shape = /** @class */ (function () {
    function Shape(type, values) {
        this.type = type;
        this.dimensions = __spreadArray([], values, true);
    }
    /**
     * Parse a string like "u8[1, 2, 3]" into a Shape.
     */
    Shape.parse = function (text) {
        var pattern = /^([\w\d]+)\[(\d+(?:,\s*\d+)*)\]$/;
        var match = pattern.exec(text.replace(" ", ""));
        if (!match) {
            throw new Error();
        }
        var _ = match[0], typeName = match[1], dims = match[2];
        checkElementType(typeName, text);
        return new Shape(typeName, dims.split(",").map(function (d) { return parseInt(d.trim()); }));
    };
    Object.defineProperty(Shape.prototype, "rank", {
        /**
         * The number of dimensions this tensor has.
         */
        get: function () {
            return this.dimensions.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Shape.prototype, "tensorSize", {
        /**
         * The number of elements in this tensor.
         */
        get: function () {
            return this.dimensions.reduce(function (product, dim) { return product * dim; }, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Shape.prototype, "byteSize", {
        /**
         * The number of bytes used to store this tensor's elements.
         */
        get: function () {
            var sizes = Shape.ByteSize;
            var elementSize = sizes[this.type] || 1;
            return this.tensorSize * elementSize;
        },
        enumerable: false,
        configurable: true
    });
    Shape.prototype.toString = function () {
        var _a = this, type = _a.type, dimensions = _a.dimensions;
        var dims = dimensions.join(", ");
        return "".concat(type, "[").concat(dims, "]");
    };
    Shape.ByteSize = {
        "f64": 8,
        "i64": 8,
        "u64": 8,
        "f32": 4,
        "i32": 4,
        "u32": 4,
        "u16": 2,
        "i16": 2,
        "u8": 1,
        "i8": 1
    };
    return Shape;
}());
exports.default = Shape;
function checkElementType(typeName, input) {
    var knownElements = Object.keys(Shape.ByteSize);
    if (typeName in Shape.ByteSize) {
        return;
    }
    console.warn("The \"".concat(typeName, "\" in \"").concat(input, "\" isn't one of the known element types (").concat(knownElements, ")"));
}
